import { BrowserRouter, Routes, Route } from 'react-router-dom';

export const appRouter = (pages) => {
    const router = () => {
        return (
            <>
                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    <Routes>
                        {pages.map((p) => (
                            <Route key={p.key} path={p.path} element={p.element}/>
                        ))}
                    </Routes>
                </BrowserRouter>
            </>
        );
    };
    return {
        browserRouter: router(),
    };
};